import React from "react";
import { PaymentSummary } from "../payment-summary/payment-summary";

export const PayableReviewSummary = () => {
  return (
    <PaymentSummary
      showDueDate={true}
      showAmountDue={true}
      conditionalPaymentMethod={false}
      businessUnitDataCy="ez-pay-summary-field-item-invoice-number"
    />
  );
};